import React from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import { useUpdateProviderMutation } from "../../../../features/provider/providerApiSlice";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../features/auth/authSlice";
import { useCreateLogsMutation } from "../../../../features/logs/logsApiSlice";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
} from "../../../../constants/config.constants";

const ProviderTypeUpdate = ({ open, setOpen, provider,setProvider, marketId }) => {
  const user = useSelector(selectUser);
  const [updateProvider, { isLoading: updateProviderLoading }] =
    useUpdateProviderMutation();
  const [createLog] = useCreateLogsMutation();


  const handleUpdateProvider = async () => {
    const payload = {
      activity: `Provider (${provider.name}) type updated by User ${user?.details?.name}`,
      type: ACTIVITY_TYPE.PROVIDER_UPDATE,
      data: {
        providerId: provider.id,
      },
    };
    try {
      const { data } = await updateProvider({
        ...provider,
        providerId: provider.id,
        marketProfileId: marketId,
      }).unwrap();
      setProvider((prev) => ({ ...prev, ...data }));
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
    } catch (error) {
      console.error(error?.data?.message);
      await createLog({
        ...payload,
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
    }
  };


  return (
    <ReusableModal
    hideHeader
      open={open}
      title={"Edit provider"}
      onClose={() => {
        setOpen(false);
      }}
    >
      <div className="flex flex-col items-center min-w-[480px]">
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <div className="flex flex-col w-full gap-4 p-4 overflow-auto max-h-[calc(100vh-200px)]">
        <div className="flex flex-col gap-1">
            <span className="text-xl font-bold">Confirm Type Change</span>
            <span className="text-md text-primarytextgrey">This will update the provider's employment type.</span>
        </div>
        </div>
        <div className="flex flex-col gap-2 w-full">
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <p className="text-md text-start px-4 py-3">Are you sure you want to change the provider type?</p>
        </div>
        <div className="justify-end w-full px-3 mb-2 d-flex gap-3">
          <button
            className="w-[120px]  disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-1 rounded-md bg-secondarygrayborder text-primaryblack whitespace-nowrap"
            onClick={async () => {
            setProvider((prev) => ({ ...prev, employment_type: provider.employment_type === "Per Diem" ? "Full-Time" : "Per Diem" }));
              setOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="w-[120px]  disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-1 rounded-md bg-primaryblue text-white whitespace-nowrap"
            onClick={async () => {
              await handleUpdateProvider();
              setOpen(false);
            }}
          >
            {updateProviderLoading ? "Saving..." : "Confirm"}
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ProviderTypeUpdate;
